export function formatarKz(valor: number): string {
  return valor.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
}

export function formatarValorMoeda(valor: string): string {
  const digitos = valor.replace(/\D/g, '').replace(/^0+(?=\d)/, '')

  if (!digitos) return ''

  const centavos = digitos.padStart(3, '0')
  const inteiro = centavos.slice(0, -2).replace(/\B(?=(\d{3})+(?!\d))/g, '.')
  const decimal = centavos.slice(-2)

  return `${inteiro},${decimal}`
}

export function bloquearTeclaNaoNumerica(event: KeyboardEvent): void {
  if (event.key.length === 1 && !/\d/.test(event.key)) {
    event.preventDefault()
  }
}

export function paraNumero(valorTexto: string): number {
  if (!valorTexto) return 0

  const numero = Number(valorTexto.replace(/\./g, '').replace(',', '.'))

  return Number.isNaN(numero) ? 0 : numero
}

export function numeroDaApi(valor: unknown): number {
  if (typeof valor === 'number') return valor
  if (valor == null || valor === '') return 0

  const texto = String(valor).trim()
  const numero = Number(texto.includes(',') ? texto.replace(/\./g, '').replace(',', '.') : texto)

  return Number.isNaN(numero) ? 0 : numero
}
